import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccountService } from 'src/app/account/services/account.service';
import { catchError, map, Observable, of } from 'rxjs';
import { AlertService } from 'src/app/shared/services/alert.service';

@Injectable({
  providedIn: 'root'
})
export class PrimaryGuard implements CanActivate {

  constructor(private authService: AuthService,
    private accountService: AccountService,
    private router: Router,
    private alertService: AlertService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated)
      return true;

    let observable = Observable.create(async o => {
      let primary = await this.accountService.$primary.toPromise();
      if (primary) {
        o.next(true);
        return;
      }
        
      await this.alertService.showTranslate('Account.ChoosePrimaryCardToCheckout');
      o.next(this.router.parseUrl('/account'));
    });

    return observable;
  }


}
